import type { FilterBillingCycleLabels, FilterStateLabels, FilterTierLabels } from './types'

export const mapLabelsToCheckboxOptions = (
  labels: FilterBillingCycleLabels | FilterStateLabels | FilterTierLabels,
) =>
  Object.entries(labels).map(([key, value]) => {
    return {
      label: value,
      value: key,
    }
  })
